import React, {useState} from 'react'
import _ from 'lodash'
import {
    addPart as addComparePart,
    removePart as removeComparePart,
    selectCompareParts
} from '../table/compareSlice'
import { useSelector, useDispatch } from 'react-redux'
import isAuthorized from "../../utils/constants/isAuthorized";
import isProd from "../../utils/constants/isProd";
import searchParams from "../../utils/constants/searchParams";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { fillHeaderCompareSvg } from "./CompareFunctions";
import { redColor } from "../../utils/constants/compareParts";

const CompareIcon = ({ part_id, hash, article, brand }) => {
    const dispatch = useDispatch()
    const compareParts = useSelector(selectCompareParts)

    const partInCompare = _.find(compareParts, { hash })
    const isPartInCompare = typeof partInCompare !== 'undefined'
    const isFullCompare = _.size(compareParts) > 3
    const [status, setStatus] = useState(null);

    const addComparePartHandler = (hash, part_id, article, brand) => (e) => {
        if(_.size(compareParts)<4 && isAuthorized) {
            if (isProd) {
                const ajaxCompareUrl = '/auto/search/compare/ajax.php'
                const data = new URLSearchParams()
                data.append('action', 'add_to_compare')
                data.append('part_id', part_id)
                data.append('article', article)
                data.append('brand_title', brand)
                data.append('search_id', searchParams.QUERY.toUpperCase())

                axios
                    .post(ajaxCompareUrl, data)
                    .then((response) => {
                        const isSuccess = response.status === 200 && response.data.success === true;

                        if (isSuccess) {
                            fillHeaderCompareSvg(redColor)
                        }
                    })
            }

            dispatch(addComparePart({hash: hash, part_id: part_id, article: article, brand: brand}))
        } else {
            ReactTooltip.show(status)
        }
    }

    const removeComparePartHandler = (id, hash) => (e) => {
        if (isProd) {
            const ajaxCompareUrl = '/auto/search/compare/ajax.php'
            const data = new URLSearchParams()
            data.append('action', 'remove_from_compare')
            data.append('article', article)
            data.append('brand_title', brand)

            axios
                .post(ajaxCompareUrl, data)
                .then(() => {
                    if (compareParts.length === 1) {
                        fillHeaderCompareSvg()
                    }
                })
        }

        dispatch(removeComparePart({hash: hash}))
    }

    return (
        <div
            className="result-table__info-compare-icon"
            onClick={
                isPartInCompare
                    ? removeComparePartHandler(partInCompare['id'], hash)
                    : addComparePartHandler(hash, part_id, article, brand)
            }

            data-for={isFullCompare? ("tooltip_compare"):("")}
            data-tip="custom"
            data-event="click"
            ref={(ref) => setStatus(ref)}
        >
            {isPartInCompare ? (
                <svg fill="#ef4a3d" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 30.016h20v-4h-20v4zM0 22.016h28v-4h-28v4zM0 14.016h24v-4h-24v4zM0 6.016h32v-4h-32v4z"></path>
                </svg>
            ) : (
                <svg fill="#B0B0AD" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 30.016h20v-4h-20v4zM0 22.016h28v-4h-28v4zM0 14.016h24v-4h-24v4zM0 6.016h32v-4h-32v4z"></path>
                </svg>
            )}
        </div>
    )
}

export default CompareIcon
